<p *ngIf="!hasLoaded" class="alert alert-warning">Loading...</p>
<p *ngIf="hasLoaded && loadFailed" class="alert alert-warning">Failed to load homework assignments.  Check your connection or contact support.</p>
<div *ngIf="hasLoaded && !loadFailed">
  <input class="form-control" placeholder="Filter by name..." (keyup)="searchTitle($event.target.value)" />
  <select (change)="searchTag($event.target.value)" class="browser-default form-control">
    <option *ngFor="let tag of tags" [value]="tag.value">{{tag.label}}</option>
  </select>
  <ul class="list-group" *ngIf="hasLoaded">
    <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-action"
      *ngFor="let asset of Assets" (click)="pick(asset)">
      <span *ngIf="asset.type == 'article'"> <a class="badge badge-pill badge-primary mr-2" [routerLink]="['/admin','library','articles',asset.id]"><i class='fa fa-info'></i></a>{{asset.title}} <em class="small">- Article</em></span>
      <span *ngIf="asset.type == 'assignment'"> <a class="badge badge-pill badge-primary mr-2" [routerLink]="['/admin','library','exercises',asset.id]"><i class='fa fa-info'></i></a>{{asset.title}} <em class="small">- Exercise</em></span>
      <span class="badge badge-primary badge-pill btn btn-sm btn-primary" alt="Assign Homework"
        title="Assign Homework">Add
      </span>
    </li>
  </ul>
</div>


// WEBPACK FOOTER //
// ./src/app/library-assets/asset-picker/asset-picker.component.html